<div>frontendVersion: {{ frontendVersion }}</div>
@if (backendVersion) {
    <div>backendVersion: {{ backendVersion }}</div>
}
